module.exports = __webpack_public_path__ + "img/nave-01.0418859b.jpg";